import { render, staticRenderFns } from "./WhatsappSolutionComparisonModal.vue?vue&type=template&id=c9d8d834"
import script from "./WhatsappSolutionComparisonModal.vue?vue&type=script&lang=js"
export * from "./WhatsappSolutionComparisonModal.vue?vue&type=script&lang=js"
import style0 from "./WhatsappSolutionComparisonModal.vue?vue&type=style&index=0&id=c9d8d834&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports